import { UserOffice } from "@/type/core/auth/auth.types";
import { ModelMailHandler } from "@/type/core/models/models.types";
import { createStore } from "effector";
import { setSelectedOfficeForModelMail } from "@state/modelMail/ModelMailEvents";

export const modelMailStore = createStore<ModelMailHandler>({
  selectedOffice: undefined,
}).on<UserOffice | undefined>(
  setSelectedOfficeForModelMail,
  (state: ModelMailHandler, payload: UserOffice | undefined) => {
    return {
      ...state,
      selectedOffice: payload,
    };
  },
);
